import { format, isThisWeek, isToday, isYesterday } from "date-fns";

export function formatRelativeDate( data: Date ): string {
  if ( isToday( data )) {
    return format(data, "HH:mm");
  }

  if ( isYesterday( data )) {
    return "Ontem";
  }

  if ( isThisWeek( data, { weekStartsOn: 1 })) {
    return format( data, "EEEE");
  }

  return format( data, "dd/MM/yyyy");
}

export function formatRelativeDateWithHour( data: Date ): string {
  if ( isToday( data )) {
    return format(data, "HH:mm");
  }

  if ( isYesterday( data )) {
    return `Ontem às ${ format(data, "HH:mm")}`;
  }

  if ( isThisWeek( data, { weekStartsOn: 1 })) {
    return format( data, "EEEE 'às' HH:mm");
  }

  return format( data, "dd/MM/yyyy 'às' HH:mm");
}
